const ProductCustomizerFormRoseCounts = {
  //
  // LE DUO COUNTS
  //
  'le-duo-magnifique-custom': {
    a: { _flower_1_count: 30, _flower_2_count: 20 },
    b: { _flower_1_count: 30, _flower_2_count: 20 },
    c: { _flower_1_count: 30, _flower_2_count: 20 },
    d: { _flower_1_count: 30, _flower_2_count: 20 },
    e: { _flower_1_count: 30, _flower_2_count: 20 },
    f: { _flower_1_count: 30, _flower_2_count: 20 },
    g: { _flower_1_count: 30, _flower_2_count: 20 },
    h: { _flower_1_count: 30, _flower_2_count: 20 },
    i: { _flower_1_count: 30, _flower_2_count: 20 },
    j: { _flower_1_count: 30, _flower_2_count: 20 },
    k: { _flower_1_count: 30, _flower_2_count: 20 },
    l: { _flower_1_count: 30, _flower_2_count: 20 },
    m: { _flower_1_count: 30, _flower_2_count: 20 },
    n: { _flower_1_count: 30, _flower_2_count: 20 },
    o: { _flower_1_count: 30, _flower_2_count: 20 },
    p: { _flower_1_count: 30, _flower_2_count: 20 },
    q: { _flower_1_count: 30, _flower_2_count: 20 },
    r: { _flower_1_count: 30, _flower_2_count: 20 },
    s: { _flower_1_count: 30, _flower_2_count: 20 },
    t: { _flower_1_count: 30, _flower_2_count: 20 },
    u: { _flower_1_count: 30, _flower_2_count: 20 },
    v: { _flower_1_count: 30, _flower_2_count: 20 },
    w: { _flower_1_count: 30, _flower_2_count: 20 },
    x: { _flower_1_count: 30, _flower_2_count: 20 },
    y: { _flower_1_count: 30, _flower_2_count: 20 },
    z: { _flower_1_count: 30, _flower_2_count: 20 },
    0: { _flower_1_count: 30, _flower_2_count: 20 },
    1: { _flower_1_count: 30, _flower_2_count: 20 },
    2: { _flower_1_count: 30, _flower_2_count: 20 },
    3: { _flower_1_count: 30, _flower_2_count: 20 },
    4: { _flower_1_count: 30, _flower_2_count: 20 },
    5: { _flower_1_count: 30, _flower_2_count: 20 },
    6: { _flower_1_count: 30, _flower_2_count: 20 },
    7: { _flower_1_count: 30, _flower_2_count: 20 },
    8: { _flower_1_count: 30, _flower_2_count: 20 },
    9: { _flower_1_count: 30, _flower_2_count: 20 },
    checkered: { _flower_1_count: 30, _flower_2_count: 20 },
    'h-stripes': { _flower_1_count: 30, _flower_2_count: 20 },
    'v-stripes': { _flower_1_count: 30, _flower_2_count: 20 },
    'star symbol': { _flower_1_count: 38, _flower_2_count: 7, _petit_flower_2_count: 30 },
    'moon symbol': { _flower_1_count: 37, _flower_2_count: 12, _petit_flower_2_count: 5 },
    'heart symbol': { _flower_1_count: 30, _flower_2_count: 20 },
    '#': { _flower_1_count: 30, _flower_2_count: 20 },
    $: { _flower_1_count: 30, _flower_2_count: 20 },
    solid: { _flower_1_count: 50 },
  },
  //
  // GRANDIOSE COUNTS
  //
  'grandiose-custom': {
    a: { _flower_1_count: 20, _flower_2_count: 14 },
    b: { _flower_1_count: 20, _flower_2_count: 14 },
    c: { _flower_1_count: 20, _flower_2_count: 14 },
    d: { _flower_1_count: 20, _flower_2_count: 14 },
    e: { _flower_1_count: 20, _flower_2_count: 14 },
    f: { _flower_1_count: 20, _flower_2_count: 14 },
    g: { _flower_1_count: 20, _flower_2_count: 14 },
    h: { _flower_1_count: 20, _flower_2_count: 14 },
    i: { _flower_1_count: 20, _flower_2_count: 14 },
    j: { _flower_1_count: 20, _flower_2_count: 14 },
    k: { _flower_1_count: 20, _flower_2_count: 14 },
    l: { _flower_1_count: 20, _flower_2_count: 14 },
    m: { _flower_1_count: 20, _flower_2_count: 14 },
    n: { _flower_1_count: 20, _flower_2_count: 14 },
    o: { _flower_1_count: 20, _flower_2_count: 14 },
    p: { _flower_1_count: 20, _flower_2_count: 14 },
    q: { _flower_1_count: 20, _flower_2_count: 14 },
    r: { _flower_1_count: 20, _flower_2_count: 14 },
    s: { _flower_1_count: 20, _flower_2_count: 14 },
    t: { _flower_1_count: 20, _flower_2_count: 14 },
    u: { _flower_1_count: 20, _flower_2_count: 14 },
    v: { _flower_1_count: 20, _flower_2_count: 14 },
    w: { _flower_1_count: 20, _flower_2_count: 14 },
    x: { _flower_1_count: 20, _flower_2_count: 14 },
    y: { _flower_1_count: 20, _flower_2_count: 14 },
    z: { _flower_1_count: 20, _flower_2_count: 14 },
    0: { _flower_1_count: 20, _flower_2_count: 14 },
    1: { _flower_1_count: 20, _flower_2_count: 14 },
    2: { _flower_1_count: 20, _flower_2_count: 14 },
    3: { _flower_1_count: 20, _flower_2_count: 14 },
    4: { _flower_1_count: 20, _flower_2_count: 14 },
    5: { _flower_1_count: 20, _flower_2_count: 14 },
    6: { _flower_1_count: 20, _flower_2_count: 14 },
    7: { _flower_1_count: 20, _flower_2_count: 14 },
    8: { _flower_1_count: 20, _flower_2_count: 14 },
    9: { _flower_1_count: 20, _flower_2_count: 14 },
    checkered: { _flower_1_count: 20, _flower_2_count: 14 },
    'h-stripes': { _flower_1_count: 20, _flower_2_count: 14 },
    'v-stripes': { _flower_1_count: 20, _flower_2_count: 14 },
    'heart symbol': { _flower_1_count: 20, _flower_2_count: 14 },
    '#': { _flower_1_count: 20, _flower_2_count: 14 },
    $: { _flower_1_count: 20, _flower_2_count: 14 },
    solid: { _flower_1_count: 34 },
  },
  //
  // LARGE SQUARE COUNTS
  //
  'large-square-custom': {
    a: { _flower_1_count: 35, _flower_2_count: 17 },
    b: { _flower_1_count: 35, _flower_2_count: 17 },
    c: { _flower_1_count: 35, _flower_2_count: 17 },
    d: { _flower_1_count: 35, _flower_2_count: 17 },
    e: { _flower_1_count: 35, _flower_2_count: 17 },
    f: { _flower_1_count: 35, _flower_2_count: 17 },
    g: { _flower_1_count: 35, _flower_2_count: 17 },
    h: { _flower_1_count: 35, _flower_2_count: 17 },
    i: { _flower_1_count: 35, _flower_2_count: 17 },
    j: { _flower_1_count: 35, _flower_2_count: 17 },
    k: { _flower_1_count: 35, _flower_2_count: 17 },
    l: { _flower_1_count: 35, _flower_2_count: 17 },
    m: { _flower_1_count: 35, _flower_2_count: 17 },
    n: { _flower_1_count: 35, _flower_2_count: 17 },
    o: { _flower_1_count: 35, _flower_2_count: 17 },
    p: { _flower_1_count: 35, _flower_2_count: 17 },
    q: { _flower_1_count: 35, _flower_2_count: 17 },
    r: { _flower_1_count: 35, _flower_2_count: 17 },
    s: { _flower_1_count: 35, _flower_2_count: 17 },
    t: { _flower_1_count: 35, _flower_2_count: 17 },
    u: { _flower_1_count: 35, _flower_2_count: 17 },
    v: { _flower_1_count: 35, _flower_2_count: 17 },
    w: { _flower_1_count: 35, _flower_2_count: 17 },
    x: { _flower_1_count: 35, _flower_2_count: 17 },
    y: { _flower_1_count: 35, _flower_2_count: 17 },
    z: { _flower_1_count: 35, _flower_2_count: 17 },
    0: { _flower_1_count: 35, _flower_2_count: 17 },
    1: { _flower_1_count: 35, _flower_2_count: 17 },
    2: { _flower_1_count: 35, _flower_2_count: 17 },
    3: { _flower_1_count: 35, _flower_2_count: 17 },
    4: { _flower_1_count: 35, _flower_2_count: 17 },
    5: { _flower_1_count: 35, _flower_2_count: 17 },
    6: { _flower_1_count: 35, _flower_2_count: 17 },
    7: { _flower_1_count: 35, _flower_2_count: 17 },
    8: { _flower_1_count: 35, _flower_2_count: 17 },
    9: { _flower_1_count: 35, _flower_2_count: 17 },
    checkered: { _flower_1_count: 35, _flower_2_count: 17 },
    'h-stripes': { _flower_1_count: 35, _flower_2_count: 17 },
    'v-stripes': { _flower_1_count: 35, _flower_2_count: 17 },
    'star symbol': { _flower_1_count: 38, _flower_2_count: 7, _petit_flower_2_count: 30 },
    'moon symbol': { _flower_1_count: 37, _flower_2_count: 12, _petit_flower_2_count: 5 },
    'heart symbol': { _flower_1_count: 35, _flower_2_count: 17 },
    '#': { _flower_1_count: 35, _flower_2_count: 17 },
    $: { _flower_1_count: 35, _flower_2_count: 17 },
    solid: { _flower_1_count: 52 },
  },
  //
  // LARAGE ROUND COUNTS
  //
  'large-round-custom': {
    a: { _flower_1_count: 29, _flower_2_count: 17 },
    b: { _flower_1_count: 29, _flower_2_count: 17 },
    c: { _flower_1_count: 29, _flower_2_count: 17 },
    d: { _flower_1_count: 29, _flower_2_count: 17 },
    e: { _flower_1_count: 29, _flower_2_count: 17 },
    f: { _flower_1_count: 29, _flower_2_count: 17 },
    g: { _flower_1_count: 29, _flower_2_count: 17 },
    h: { _flower_1_count: 29, _flower_2_count: 17 },
    i: { _flower_1_count: 29, _flower_2_count: 17 },
    j: { _flower_1_count: 29, _flower_2_count: 17 },
    k: { _flower_1_count: 29, _flower_2_count: 17 },
    l: { _flower_1_count: 29, _flower_2_count: 17 },
    m: { _flower_1_count: 29, _flower_2_count: 17 },
    n: { _flower_1_count: 29, _flower_2_count: 17 },
    o: { _flower_1_count: 29, _flower_2_count: 17 },
    p: { _flower_1_count: 29, _flower_2_count: 17 },
    q: { _flower_1_count: 29, _flower_2_count: 17 },
    r: { _flower_1_count: 29, _flower_2_count: 17 },
    s: { _flower_1_count: 29, _flower_2_count: 17 },
    t: { _flower_1_count: 29, _flower_2_count: 17 },
    u: { _flower_1_count: 29, _flower_2_count: 17 },
    v: { _flower_1_count: 29, _flower_2_count: 17 },
    w: { _flower_1_count: 29, _flower_2_count: 17 },
    x: { _flower_1_count: 29, _flower_2_count: 17 },
    y: { _flower_1_count: 29, _flower_2_count: 17 },
    z: { _flower_1_count: 29, _flower_2_count: 17 },
    0: { _flower_1_count: 29, _flower_2_count: 17 },
    1: { _flower_1_count: 29, _flower_2_count: 17 },
    2: { _flower_1_count: 29, _flower_2_count: 17 },
    3: { _flower_1_count: 29, _flower_2_count: 17 },
    4: { _flower_1_count: 29, _flower_2_count: 17 },
    5: { _flower_1_count: 29, _flower_2_count: 17 },
    6: { _flower_1_count: 29, _flower_2_count: 17 },
    7: { _flower_1_count: 29, _flower_2_count: 17 },
    8: { _flower_1_count: 29, _flower_2_count: 17 },
    9: { _flower_1_count: 29, _flower_2_count: 17 },
    'star symbol': { _flower_1_count: 38, _flower_2_count: 7, _petit_flower_2_count: 30 },
    'moon symbol': { _flower_1_count: 37, _flower_2_count: 12, _petit_flower_2_count: 5 },
    'yin yang symbol': {
      _flower_1_count: 20, _flower_2_count: 18, _petit_flower_1_count: 1, _petit_flower_2_count: 1,
    },
    'heart symbol': { _flower_1_count: 29, _flower_2_count: 17 },
    '#': { _flower_1_count: 29, _flower_2_count: 17 },
    $: { _flower_1_count: 29, _flower_2_count: 17 },
    solid: { _flower_1_count: 46 },
  },
  //
  // SMALL SQUARE COUNTS
  //
  'small-square-custom': {
    checkered: { _flower_1_count: 8, _flower_2_count: 8 },
    'h-stripes': { _flower_1_count: 8, _flower_2_count: 8 },
    'v-stripes': { _flower_1_count: 8, _flower_2_count: 8 },
    solid: { _flower_1_count: 16 },
  },
  //
  // PICTURE FRAME COUNTS
  //
  'fleur-frame-custom': {
    solid: { _flower_1_count: 18 },
  },
  //
  // L'Amour Frame Small Square counts
  //
  'small-square-white-classic-photo-box': {
    solid: { _flower_1_count: 16 },
  },

};

export default ProductCustomizerFormRoseCounts;
